'use client';

import {
  Button,
  DropdownContainer,
  DropdownContent,
  DropdownItem,
  DropdownTrigger,
  CaretDownFilled,
  useRequest,
} from '@wk/wk-uni-lib';
import { useAtom } from 'jotai';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import { getSubscriptionData } from '@/api/order';
import { useTraceCommonParams } from '@/hooks/use-trace-common-params';
import { networkOrVisibilityTickAtom } from '@/store/network-or-visiblity-store';
import { navigateToOldProject } from '@/utils/url';

const dropdownOptionLabelMap = {
  CHINESE: 'gs2-中文',
  MATH: 'gs2-数学',
  ENGLISH: 'gs2-英文',
};

export default function SubscribeButton({
  dictionary,
}: {
  dictionary: Record<string, string>;
}) {
  const { traceWithCommonParams } = useTraceCommonParams();
  const pathname = usePathname().replace('/zh', '');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [networkOrVisibilityTick] = useAtom(networkOrVisibilityTickAtom);
  const { data, refresh } = useRequest(getSubscriptionData, {
    refreshDeps: [pathname],
  });

  useEffect(() => {
    if (networkOrVisibilityTick > 0) {
      refresh();
    }
  }, [networkOrVisibilityTick]);

  const handleToSubscriptionDetail = (link: string, subject: string) => {
    traceWithCommonParams({
      _event: 'U_HP_SubscribeEnterClick',
      teacherId: '',
      courseStatus: '',
      studentType: 'GS2.0',
      subject,
    });

    navigateToOldProject(
      `${link}${link.includes('?') ? '&' : '?'}isNewNav=1&breadPath=home`,
    );
  };

  if (!data?.length) {
    return null;
  }

  if (data?.length === 1) {
    return (
      <Button
        onClick={() =>
          handleToSubscriptionDetail(
            data?.[0]?.subscriptionLink || '',
            data?.[0]?.subject || '',
          )
        }>
        {dictionary['gs2-订阅']}
      </Button>
    );
  }

  return (
    <DropdownContainer setVisible={setDropdownOpen} triggerType="hover">
      <DropdownTrigger>
        <Button className="relative lg:pl-[20px] lg:pr-0 hover:lg:bg-brand-red-100">
          <span className="pr-[60.5px]">{dictionary['gs2-订阅']}</span>
          <div
            className="absolute right-0 top-0 flex h-full items-center justify-center rounded-e-full bg-[#d03637] px-[12px]"
            style={{ borderLeft: '0.5px solid rgba(255, 255, 255, 0.10)' }}>
            <CaretDownFilled />
          </div>
        </Button>
      </DropdownTrigger>
      <DropdownContent visible={dropdownOpen} className="min-w-[106.5px]">
        {data?.map(item => (
          <DropdownItem
            key={item.subject}
            onClick={() => {
              handleToSubscriptionDetail(
                item.subscriptionLink || '',
                item.subject || '',
              );
            }}>
            {
              dictionary[
                dropdownOptionLabelMap[
                  item.subject as keyof typeof dropdownOptionLabelMap
                ]
              ]
            }
          </DropdownItem>
        ))}
      </DropdownContent>
    </DropdownContainer>
  );
}
